import { render, staticRenderFns } from "./TemplateFormComp.vue?vue&type=template&id=17610217"
import script from "./TemplateFormComp.vue?vue&type=script&lang=js"
export * from "./TemplateFormComp.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormComp.vue?vue&type=style&index=0&id=17610217&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports